module.exports = __webpack_public_path__ + "static/img/quesionbank.bbcfd9a3.svg";